export default __webpack_public_path__ + "static/1157-9e472a7ebf349eb19301cd77adc80492.gif";